import React from 'react';
import { BookImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin, P, Span } from '@helpers';
import { getImage } from "gatsby-plugin-image"

export const WritingGoals = ({getPng, t}) => {
  return (
    <PageWrapper darkMode={false}>
      <FlexDiv>
        <BookImg image={getImage(getPng("book"))} alt="book"/>
        <Text width='340px' marginLeft='31px' marginTop='141px' paddingBefforeText="45px">
          <h1>{t("Writing goals")}</h1>
          <p>
            {t("Soft-FX is a high-tech company that provides its clients with products and services for digital trading.")}
          </p>
        </Text>
      </FlexDiv>
        <Container paddingTop='63px' marginLeft='102px' paddingBottom='84px'>
          <FlexDiv>
            <Text width='437px' paddingAffterText="30px">
              <p>
                {t("As an entity that grew out of a small business and has passed the care about clients through more than a decade of our history, we continue to put the interests of our customers and the security of their funds first. Therefore,")}
                <Span weight='600'>
                  {t("our reputation is based on our customers' trust in our abilities and in the reliability of our products.")}
                </Span>
              </p>
              <p>
                {t("The main thing we rely on in our work is our customers' trust in our abilities and in the reliability of our products. If this trust is lost for any reason, it could jeopardize the very existence of the company in its present form.")} 
                <Span weight='600'>
                {t("Thus, the main purpose of the content that is created internally or by third parties is to establish and strengthen customers' trust in Soft-FX products and solutions.")}
                </Span>
              </p>
            </Text>
            <Margin maxWidth='280px' marginTop='132px' marginLeft='39px'>
              <P weight='700' size='40px' height='48.86px' align='center' transform='uppercase' space='0.02em' color='#f2f2f2'>
                {t("reputation")}
                <br/>—<br/>
                {t("customers")}
                <br/>—<br/>
                {t("trust")}
              </P>
            </Margin>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};